import { html } from '@genesislcap/web-core';
import './bond-data-import';
import type { AppManagementWatchlistBondsManager } from './watchlist-bonds';
import {customEvent} from '@genesislcap/foundation-events';

export const WatchlistBondsTemplate = html<AppManagementWatchlistBondsManager>`
  <entity-management
    design-system-prefix="rapid"
    header-case-type="capitalCase"
    enable-row-flashing
    enable-cell-flashing
    resourceName="ALL_USER_WATCHLIST"
    deleteEvent="EVENT_WATCHLIST_BONDS_DELETE"
    createEvent="EVENT_WATCHLIST_BONDS_UPSERT"
    :columns=${(x) => x.columns}
    :createFormUiSchema=${(x) => x.createFormUiSchema}
    :updateFormUiSchema=${(x) => x.updateFormUiSchema}
    modal-position="centre"
    size-columns-to-fit
    persist-column-state-key="watchlist-bonds-grid"
    row-selection="multiple"
    :datasourceConfig="${(x) => x.datasourceConfig}"
    title="Watchlist Management">

    <div slot="footer" style="display: flex; justify-content: flex-end; align-items: baseline; padding: 10px; gap: 10px;"> 
      <bond-data-import @csv-data-imported=${(x, ctx) => x.onCsvDataImported(customEvent(ctx))}></bond-data-import>
    </div>
  </entity-management>
`; 
